function getSafetyLookupBaseUrl() {
    const base = process.env.VUE_APP_SAFETY_LOOKUP_API_BASE_URL || "https://safety-lookup.qrexl.ink/";
    return base.endsWith("/") ? base : `${base}/`;
}

function getSafetyLookupClassifyUrl() {
    return new URL("v1/classify", getSafetyLookupBaseUrl()).toString();
}

function isValidHttpUrl(url) {
    try {
        if (!url || typeof url !== "string" || url.length === 0) return false;
        const parsed = new URL(url);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        return false;
    }
}

async function classifyRedirectUrl(url) {
    const res = await fetch(getSafetyLookupClassifyUrl(), {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            url,
            resolve_redirects: true,
            include_redirect_chain: true,
        }),
    });

    const contentType = res.headers.get("content-type") || "";
    const data = contentType.includes("application/json") ? await res.json() : await res.text();

    if (!res.ok) {
        const message =
            data && typeof data === "object" && data.error
                ? data.error
                : `Safety lookup failed (${res.status})`;
        throw new Error(message);
    }

    return data;
}

export {
    classifyRedirectUrl,
    getSafetyLookupBaseUrl,
    isValidHttpUrl,
};
